/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".account[_ngcontent-%COMP%]{position:fixed;top:0;left:0;right:0;height:100%;width:100%;opacity:0;visibility:hidden;transition:opacity .5s ease,visibility .5s ease;z-index:11;background:#060606;padding-top:45px}.account.is-visible[_ngcontent-%COMP%]{opacity:1;visibility:visible}.account__inner[_ngcontent-%COMP%]{padding:20px 15px 15px;max-width:1024px;width:100%;margin:0 auto}@media screen and (min-width:660px){.account__inner[_ngcontent-%COMP%]{padding:40px 25px 15px}}"];
export { styles as styles };
